"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardSalesOrder = void 0;
const enums_1 = require("../../enums");
const product_dashboard_sales_order_customer_response_1 = require("./product-dashboard-sales-order-customer.response");
class ProductDashboardSalesOrder {
}
exports.ProductDashboardSalesOrder = ProductDashboardSalesOrder;
//# sourceMappingURL=product-dashboard-sales-order.response.js.map